import { media, style } from "typestyle";
import { queries } from "../../styles/styles";

export const purchaseActions = style(
  {
    display: "none",
    minHeight: "33px",
    minWidth: "37px",
  },
  media(queries.medium),
  {
    display: "flex",
    justifyContent: "flex-end",
  },
);

export const arrow = style(
  {
    display: "block",
    background: "none",
    outline: "none",
    border: "none",
  },
  media(queries.medium, {
    display: "none",
  }),
);

export const expandableButtons = style({
  padding: "4px",
  border: "1px solid rgba(0,0,0,0.05)",
  backgroundColor: "rgba(247, 245, 243, 1)",
  borderRadius: "6px",
  width: "fit-content",
  display: "flex",
  position: "absolute",
  $nest: {
    "&>*:not(:last-child)": {
      marginRight: "4px",
    },
  },
});
